import React from 'react';
import CheckoutSection from '../Section';
import Collapsed from './Collapsed';
import Expanded from './Expanded';

export default function CustomerInfo({
  isExpanded,
  canEdit,
  expand,
  collapse
}) {
  return (
    <CheckoutSection
      isExpanded={isExpanded}
      canEdit={canEdit}
      expand={expand}
      collapse={collapse}
      Expanded={Expanded}
      Collapsed={Collapsed}
      alignTop={canEdit}
    />
  );
}
